// On-demand fetch of the site's network-defaults proposal (the allocation-
// derived router/firewall values the editors prefill with). Disabled by
// default — enable it when the operator clicks "Prefill from allocation".
// `retry: false`: a 404/422 is a state (no site / unmet prereq), not a
// transient error, and the caller renders it as a prereq list.

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { networkDefaults } from "../../api/endpoints/networkDefaults";
import { qk } from "../../api/queryKeys";
import type { NetworkDefaultsOut } from "../../api/types/networkDefaults";

export function useNetworkDefaults(
  siteSlug: string,
  opts?: { enabled?: boolean; attempt?: number },
): UseQueryResult<NetworkDefaultsOut> {
  // `attempt` is a per-action nonce: bumping it makes each "Prefill" / "Apply"
  // a distinct cache entry, so a fresh proposal is always fetched (a retry
  // after a 422 actually re-runs; a previous success/cancel can't be served
  // stale into a re-entered form).
  return useQuery({
    enabled: opts?.enabled ?? false,
    retry: false,
    queryKey:
      opts?.attempt !== undefined
        ? [...qk.networkDefaults(siteSlug), opts.attempt]
        : qk.networkDefaults(siteSlug),
    queryFn: () => networkDefaults.get(siteSlug).then((r) => r.data),
  });
}
